import React from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";

// Order timeline on the pharmacy order detail pages. It uses the same steps as the Orders page
// status filters (Pending → Packed → Shipped → Delivered), so both always show the same progress.

// Words in any status text the APIs use, by how far the order has got (0 = just placed / pending)
const STEP_WORDS: [number, string[]][] = [
  [3, ["delivered", "completed", "fulfilled"]],
  [2, ["shipped", "out for delivery", "outfordelivery", "on route", "onroute", "dispatched", "picked"]],
  [1, ["packed", "assigned", "accepted", "confirmed", "ready"]],
];

const stepOf = (status?: string | null) => {
  // "Unassigned" / "Not delivered" and the like are not progress
  const text = String(status || "")
    .toLowerCase()
    .replace(/\b(un|not\s*)(assigned|packed|shipped|delivered)\b/g, "");
  for (const [step, words] of STEP_WORDS) {
    if (words.some((word) => text.includes(word))) return step;
  }
  return 0;
};

// The furthest step any of the given statuses reports (the order's own status, the details
// timeline and the delivery status can each lag behind the others)
export const getOrderStep = (...statuses: (string | null | undefined)[]) =>
  Math.max(0, ...statuses.map(stepOf));

// The status text that is furthest along (the first one given wins a tie), e.g. the order's own
// "Delivered" over a details timeline still saying "OrderPlaced"
export const getFurthestStatus = (...statuses: (string | null | undefined)[]) => {
  let best = "";
  let bestStep = -1;
  statuses.forEach((status) => {
    const text = String(status || "").trim();
    if (!text) return;
    const step = stepOf(text);
    if (step > bestStep) {
      best = text;
      bestStep = step;
    }
  });
  return best;
};

export const buildOrderTimeline = (step: number) => [
  { label: "Order Placed", completed: true, icon: <WSIcons.FiPackage /> },
  { label: "Packed", completed: step >= 1, icon: <WSIcons.TbUserSquareRounded /> },
  { label: "Shipped", completed: step >= 2, icon: <WSIcons.RiRidingLine /> },
  { label: "Delivered", completed: step >= 3, icon: <WSIcons.BsArrowUpSquare /> },
];
